import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { AutoCompleteItem, Dropdown } from "@/components/Dropdown/Dropdown";
import { Information } from "@/components/Information/Information";

import {
	HubspotLeadSyncTriggerWithInherit,
	ListLeadSyncTriggerResponse,
} from "../../../../Company/schema/hubspot";

interface HubspotLeadSyncSectionProps {
	isHubspotEnabled: boolean;
	isConnected: boolean;
	listLeadSyncTrigger: ListLeadSyncTriggerResponse | undefined;
	selectedLeadSyncTrigger: HubspotLeadSyncTriggerWithInherit | undefined;
	setSelectedLeadSyncTrigger: (trigger: HubspotLeadSyncTriggerWithInherit) => void;
}

export const HubspotLeadSyncSection: FunctionComponent<HubspotLeadSyncSectionProps> = ({
	isHubspotEnabled,
	isConnected,
	listLeadSyncTrigger,
	selectedLeadSyncTrigger,
	setSelectedLeadSyncTrigger,
}) => {
	const { t } = useTranslation();
	const tsSettings = (key: string) => t(`list.settings.${key}`);

	if (!isHubspotEnabled || !isConnected) {
		return null;
	}

	const options = Object.values(HubspotLeadSyncTriggerWithInherit).map((trigger) => ({
		id: trigger,
		title: tsSettings(`hubspot.leadSyncTrigger.${trigger}`),
	}));

	return (
		<div className="mt-8 flex w-full flex-col">
			<div className="mb-4 flex w-full flex-col gap-2">
				<div className="text-ssm font-medium text-text">
					{tsSettings("hubspot.leadSyncTrigger.title")}{" "}
					<Information information={tsSettings("hubspot.leadSyncTrigger.description")} />
				</div>
			</div>
			<Dropdown
				data={options}
				defaultValue={
					selectedLeadSyncTrigger
						? options.find((option) => option.id === selectedLeadSyncTrigger)
						: undefined
				}
				floating={true}
				handleSelect={(value: AutoCompleteItem) => {
					setSelectedLeadSyncTrigger(value.id as HubspotLeadSyncTriggerWithInherit);
				}}
			/>
			{listLeadSyncTrigger?.isInherited && (
				<div className="mt-2 text-ssm text-text-meta">
					{tsSettings("hubspot.leadSyncTrigger.inheritedFrom")}:{" "}
					{tsSettings(`hubspot.leadSyncTrigger.${listLeadSyncTrigger.effectiveTrigger}`)}
				</div>
			)}
		</div>
	);
};
